import React from "react";
import { Col, Row } from "reactstrap";
import MprStatCardShimmer from "../../common/shimmer/MprStatCardShimmer";
import { DonutChartCardShimmer, BarChartCardShimmer } from "../../common/shimmer/ChartCardShimmers";
import PatientListPanelShimmer from "../../common/shimmer/PatientListPanelShimmer";

const MonthlyPerformanceShimmer = () => (
  <div className="mpr-shimmer-wrap" aria-busy="true" aria-label="Loading report">
    <Row className="mpr-stat-row">
      {["blue", "green", "yellow", "red"].map((tone) => (
        <Col md="3" sm="6" key={tone} className="mb-3 mb-md-0">
          <MprStatCardShimmer tone={tone} />
        </Col>
      ))}
    </Row>

    <Row className="mpr-chart-row">
      <Col md="5" className="mb-3 mb-md-0">
        <DonutChartCardShimmer />
      </Col>
      <Col md="7">
        <BarChartCardShimmer />
      </Col>
    </Row>

    <PatientListPanelShimmer rowCount={6} />
  </div>
);

export default MonthlyPerformanceShimmer;
